import FilterOption from '@/models/FilterOption';
import Filter from '@/models/Filter';
import SearchResultElement from '@/models/SearchResultElement';
import i18n from '../i18n';

export default class HelperService {
  public static translatedFilterOption(filterOption: FilterOption): string {
    const transKey = `sideBar.filterOverwrite.${filterOption.filterId}.options.${filterOption.id}`;
    return (i18n.te(transKey) ? i18n.t(transKey) : filterOption.text) as string;
  }

  public static translatedFilter(filter: Filter): string {
    const transKey = `sideBar.filterOverwrite.${filter.id}.text`;
    return (i18n.te(transKey) ? i18n.t(transKey) : filter.text) as string;
  }

  public static createAnalyticsCategory(searchResultElement: SearchResultElement): string {
    const categories = [
      searchResultElement.categoryTop,
      searchResultElement.categoryHigh,
      searchResultElement.categoryMedium,
      searchResultElement.categoryLow,
    ];
    const uniqueCategories = [
      ...new Set(categories.filter((category: string) => category.length > 0)),
    ];

    return uniqueCategories.join('/');
  }
}
